const STATUS_BADGE = {
  approved: { background: '#1A5C25', symbol: '✓', label: 'Approved' },
  rejected: { background: '#7B1C1C', symbol: '✕', label: 'Rejected' },
  auto_approved: { background: '#555', symbol: '✓', label: 'Auto-approved' },
};

export default function PhotoThumbnail({ photo, isSelected, status, onClick, overlayAction }) {
  const badge = STATUS_BADGE[status];

  return (
    <div style={{ position: 'relative', cursor: 'pointer' }} onClick={onClick}>
      <img
        src={photo.thumbnailURL ?? photo.displayURL}
        alt=""
        style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block' }}
      />

      {overlayAction ? (
        <div
          style={{ position: 'absolute', top: 8, right: 8 }}
          onClick={e => e.stopPropagation()}
        >
          {overlayAction}
        </div>
      ) : isSelected && (
        <div style={{
          position: 'absolute', top: 8, right: 8,
          background: '#2E75B6', color: 'white',
          borderRadius: '50%', width: 24, height: 24,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 14, fontWeight: 'bold',
        }}>
          ✓
        </div>
      )}

      {badge && (
        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0,
          background: badge.background,
          color: 'white',
          fontSize: 12,
          textAlign: 'center',
          padding: '3px 0',
        }}>
          {badge.symbol} {badge.label}
        </div>
      )}
    </div>
  );
}